import { connect } from 'react-redux';
import _ from 'lodash';

import ChoicePage from './ChoicePage';

const mapState = state => ({
	songsCategory: _.find(state.categories.data, { order: 0 }),
	artistsCategory: _.find(state.categories.data, { order: 1 }),
	albumsCategory: _.find(state.categories.data, { order: 2 }),
	bestSongCategory: _.find(state.categories.data, { order: 3 }),
	worstSongCategory: _.find(state.categories.data, { order: 4 }),
});

const mapDispatch = {};

/* eslint-disable-next-line */
export default connect(mapState, mapDispatch)(ChoicePage);
